import { useState, useEffect } from 'react'

export default function useWindowSize() {

  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  })

  function changeWindowSize() {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight })
  }
  useEffect(() => { changeWindowSize() }, [])

  useEffect(() => {

    window.addEventListener('resize', changeWindowSize)

    return () => {
      window.removeEventListener('resize', changeWindowSize)
    }
  })

  return windowSize
}